import { render } from "./customImage.vue?vue&type=template&id=283fffae"
import script from "./customImage.vue?vue&type=script&lang=js"
export * from "./customImage.vue?vue&type=script&lang=js"

import "./customImage.vue?vue&type=style&index=0&id=283fffae&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__